module.exports = __webpack_public_path__ + "img/official-verification-icon3.e3a17728.svg";